export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Final2_09.f83e63e3.jpg";